var version = "10.82.0";

export { version as v };
//# sourceMappingURL=package-b069657d.js.map
